var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acea-row row-middle",attrs:{"id":"footer"}},_vm._l((_vm.footerList),function(item,index){return (
      item.name != '团队'
        ? true
        : item.name == '团队' && _vm.teamStatus
        ? true
        : false
    )?_c('router-link',{key:index,staticClass:"item",class:{ on: item.url == _vm.$route.fullPath },attrs:{"to":item.url,"tag":"div"}},[_c('img',{attrs:{"src":item.url == _vm.$route.fullPath ? item.icon2 : item.icon1}}),_c('div',[_vm._v(_vm._s(item.name))])]):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }